var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slick',{ref:"slick",class:"default-slider",attrs:{"options":_vm.options},on:{"init":_vm.emmiter,"reInit":_vm.handleReInit}},[_vm._t("slide")],2)}
var staticRenderFns = []

export { render, staticRenderFns }